const SvgIconClose = (props) => {
  const {
    width = 24,
    height = 24,
    enableViewBox = true,
    iconFillColor = "fill-white",
    outerFillColor = "fill-transparent",
    onClick,
    style,
    ...otherProps
  } = props;
  return (
    <svg
      className={style}
      width={width}
      height={height}
      {...(enableViewBox && { viewBox: `0 0 ${width} ${height}` })}
      onClick={onClick}
      {...otherProps}
    >
      <g className={outerFillColor} fillRule="evenodd">
        <path d="M2 2h20v20H2z" />
        <path
          d="M18.888 4.532l.801.801c.331.33.331.867.002 1.198L14.247 12l5.443 5.47c.33.33.33.867-.001 1.197l-.801.802a.848.848 0 01-1.2 0l-5.29-5.292-5.291 5.292a.849.849 0 01-1.113.075l-.087-.075-.801-.802a.848.848 0 01-.002-1.198L10.548 12 5.104 6.531a.848.848 0 01.002-1.198l.8-.801a.848.848 0 011.2 0l5.291 5.29 5.292-5.29a.848.848 0 011.2 0z"
          className={iconFillColor}
        />
      </g>
    </svg>
  );
};

export default SvgIconClose;
